// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6b2026c1","455":"9975e52f","869":"6bff19e3","977":"9d32b496"}[chunkId] + ".chunk.js";
};